import React, { PureComponent } from "react";

import styles from "./Carousel.local.scss";
import classnames from "classnames";
import _ from "i18n";

import { NB_DISPOSITIONS } from "Config";

export default class CarouselComponent extends PureComponent {
  state = {
    trigger: false,
    nbCarousel: this.props.disposition ? this.props.disposition.length : 0,
    disposition: this.props.disposition
  };

  openConfig = e => {
    const carousel = $(e.currentTarget).parents("." + styles.carousel);

    carousel.find("." + styles.params).slideUp(100);
    carousel.find("." + styles.config).slideDown(100);
  };

  closeConfig = e => {
    const carousel = $(e.currentTarget).parents("." + styles.carousel);

    carousel.find("." + styles.params).slideDown(100);
    carousel.find("." + styles.config).slideUp(100);
  };

  generateCarousel = e => {
    const { value } = e.currentTarget;
    const { setBlocDisposition, order } = this.props;
    console.log(this.props);
    let help = [...this.state.disposition];

    this.setState(
      {
        ...this.state,
        nbCarousel: parseInt(value),
        disposition: [
          ...(value >= help.length
            ? help.concat(
                new Array(value - help.length).fill(
                  "B1",
                  0,
                  value - help.length
                )
              )
            : help.slice(0, value))
        ]
      },
      () => {
        setBlocDisposition(order, this.state.disposition);
      }
    );
    /*setTimeout(e => {
      console.log(this.state);
      debugger;
    }, 10);*/
  };

  changeDisposition = (position, e) => {
    const { trigger, disposition } = this.state;
    const { setBlocDisposition, order } = this.props;

    let help = [...disposition];
    help[position] = e.currentTarget.value;

    this.setState(
      {
        ...this.state,
        disposition: [...help],
        trigger: !trigger
      },
      () => {
        setBlocDisposition(order, this.state.disposition);
      }
    );
  };

  addRow = e => {
    const { nbCarousel, disposition } = this.state;
    const { setBlocDisposition, order } = this.props;

    let help = [...disposition];

    help.push("B1");

    this.setState(
      {
        ...this.state,
        disposition: [...help],
        nbCarousel: nbCarousel + 1
      },
      () => {
        setBlocDisposition(order, this.state.disposition);
      }
    );
  };

  minusRow = (position, e) => {
    const { nbCarousel, disposition } = this.state;
    const { setBlocDisposition, order } = this.props;

    this.setState(
      {
        ...this.state,
        nbCarousel: nbCarousel - 1,
        disposition: disposition.filter((el, index) => index !== position)
      },
      () => {
        setBlocDisposition(order, this.state.disposition);
      }
    );
  };

  renderB1() {
    const { type } = this.props;
    let bloc = (
      <div className={styles.structer}>
        <span className={classnames(styles.bigSquare)} />
        <div className={styles.littleBloc}>
          <span />
          <span />
        </div>
        <div className={styles.littleBloc}>
          <span />
          <span />
        </div>
      </div>
    );

    switch (type) {
      case "EVENT":
      case "EMAILING":
        bloc = (
          <div className={classnames(styles.structer, styles.eventStruct)}>
            <span />
            <span />
            <span />
            <span />
          </div>
        );
        break;
      case "MEDIA":
        bloc = (
          <div className={classnames(styles.structer, styles.mediaStruct)}>
            <div className={styles.littleBloc}>
              <span />
              <span />
            </div>
            <div className={styles.littleBloc}>
              <span />
              <span />
            </div>
            <div className={styles.littleBloc}>
              <span />
              <span />
            </div>
            <div className={styles.littleBloc}>
              <span />
              <span />
            </div>
          </div>
        );
        break;

      default:
        break;
    }
    return bloc;
  }

  renderB2() {
    return (
      <div className={styles.structer}>
        <span className={classnames(styles.biggerSquare)} />
        <div className={styles.littleBloc}>
          <span />
          <span />
        </div>
      </div>
    );
  }

  renderB3() {
    return (
      <div className={styles.structer}>
        <div className={styles.littleBloc}>
          <span />
          <span />
        </div>
        <div className={styles.littleBloc}>
          <span />
          <span />
        </div>
        <span className={classnames(styles.bigSquare)} />
      </div>
    );
  }

  renderStruct() {
    const { nbCarousel, disposition } = this.state;
    const { type } = this.props;

    let blocs = [];
    for (let i = 0; i < nbCarousel; i++) {
      let dispo = this.renderB1();
      switch (disposition[i]) {
        case "B2":
          dispo = this.renderB2();
          break;
        case "B3":
          dispo = this.renderB3();
          break;
        default:
          break;
      }
      blocs.push(
        <li key={`dispo-${i}`}>
          <div className={styles.dispoLeft}>
            {dispo}
            <select
              className={styles.filled}
              value={disposition[i]}
              onChange={this.changeDisposition.bind(this, i)}
            >
              {new Array(NB_DISPOSITIONS[type]).fill(1).map((val, index) => (
                <option key={`nbDispo-${index}`} value={`B${index + 1}`}>
                  Disposition {index + 1}
                </option>
              ))}
            </select>
          </div>
          <ul className={classnames(styles.dispoRight, styles.plusMinus)}>
            {nbCarousel === 1 ? null : (
              <li
                className={styles.minus}
                onClick={this.minusRow.bind(this, i)}
              />
            )}
            {i === nbCarousel - 1 ? (
              <li className={styles.plus} onClick={this.addRow.bind(this)} />
            ) : null}
          </ul>
        </li>
      );
    }

    return <ul>{blocs}</ul>;
  }

  render() {
    return (
      <div className={styles.carousel}>
        <div className={styles.params}>
          <span>{_("Number of blocks in the carousel")}</span>
          <select
            className={styles.filled}
            onChange={this.generateCarousel.bind(this)}
            value={this.state.nbCarousel}
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
          <i className="icon-settings" onClick={this.openConfig.bind(this)} />
        </div>
        <div className={styles.config}>
          <div className={styles.configHead}>
            <span>{_("Carousel settings")}</span>
            <span
              className={styles.closeCarousel}
              onClick={this.closeConfig.bind(this)}
            >
              {_("Close")}
              <i className="icon-settings" />
            </span>
          </div>
          {this.renderStruct()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Carousel/CarouselComponent.js